import { CdkDrag, CdkDropList } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { GridColumn } from "../../column/column.component";
import { GridRow } from "../../row/row.component";
import { GridViewAdapter } from "../view.adapter";

@Component({
    selector: "app-grid-table",
    templateUrl: "./table.component.html",
    styleUrls: ["./table.component.scss"],
    standalone: true,
    imports: [GridRow, GridColumn, CommonModule, CdkDropList, CdkDrag],
})
export class GridTable extends GridViewAdapter {}
